import { render, staticRenderFns } from "./Opz2DetailTable.vue?vue&type=template&id=097eb9b2"
import script from "./Opz2DetailTable.vue?vue&type=script&lang=ts"
export * from "./Opz2DetailTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports